'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, activate, prepend) {
  this.uX = null;
  this.Ev = null;
  this.uY = null;
  this.uX = dynamicOwner;
  this.Ev = activate;
  this.uY = $j_java$002elang$002e$002dObject.$m_s_None$();
  dynamicOwner.S9(this, prepend);
}
export { $c_Lcom_raquo_airstream_ownership_DynamicSubscription as $c_Lcom_raquo_airstream_ownership_DynamicSubscription };
$p = $c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_DynamicSubscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicSubscription() {
}
export { $h_Lcom_raquo_airstream_ownership_DynamicSubscription as $h_Lcom_raquo_airstream_ownership_DynamicSubscription };
$h_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype = $p;
$p.xB = (function() {
  this.uX.WY(this);
});
$p.PM = (function(owner) {
  var this$2 = $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    this.uY = this.Ev.j(owner);
  });
  $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.cG || (!when))) {
    f();
  } else {
    this$2.cG = true;
    try {
      f();
    } finally {
      this$2.cG = false;
      $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
});
$p.PN = (function() {
  var this$1 = this.uY;
  if ((!this$1.k())) {
    this$1.C().xB();
    this.uY = $j_java$002elang$002e$002dObject.$m_s_None$();
  }
});
var $d_Lcom_raquo_airstream_ownership_DynamicSubscription = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_ownership_DynamicSubscription, "com.raquo.airstream.ownership.DynamicSubscription", ({
  h2: 1
}));
export { $d_Lcom_raquo_airstream_ownership_DynamicSubscription as $d_Lcom_raquo_airstream_ownership_DynamicSubscription };
